import React, { FC, useEffect, useState } from 'react'
import { Input, Modal } from 'antd'
import { useTranslation } from 'react-i18next'

type Props = {
	visible: boolean
	initialName?: string
	title?: string
	confirmLoading?: boolean
	onCancel: () => void
	onSubmit: (name: string) => void
}

const HousingAssociationModal: FC<Props> = ({
	visible,
	initialName = '',
	title,
	confirmLoading = false,
	onCancel,
	onSubmit
}) => {
	const { t } = useTranslation('pages')
	const [name, setName] = useState<string>(initialName)

	useEffect(() => {
		if (visible) {
			setName(initialName)
		}
	}, [visible, initialName])

	const handleOk = () => {
		const trimmed = name.trim()
		if (!trimmed) {
			return
		}
		onSubmit(trimmed)
	}

	return (
		<Modal
			visible={visible}
			title={title || t('pages:Bytové družstvo')}
			onCancel={onCancel}
			onOk={handleOk}
			okButtonProps={{ disabled: !name.trim(), loading: confirmLoading }}
			okText={t('pages:Uložiť')}
			cancelText={t('pages:Zrušiť')}
			destroyOnClose
		>
			<div className={'font-semibold mb-2'}>{t('pages:Názov bytového družstva')}</div>
			<Input
				autoFocus
				size={'large'}
				placeholder={t('pages:Názov bytového družstva')}
				value={name}
				onChange={(e) => setName(e.target.value)}
				onPressEnter={handleOk}
			/>
		</Modal>
	)
}

export default HousingAssociationModal
